import { Box } from '@mui/material';
import type { BoxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import { forwardRef } from 'react';

import { Neutrals } from '../../color-palette/colors';

export const surfaceSx: SystemStyleObject<Theme> = {
  minWidth: 0,
  padding: 3,
  borderRadius: 2.5,
  border: '1px solid',
  borderColor: Neutrals[100],
  backgroundColor: 'background.paper',
};

export type SurfaceCardProps = BoxProps;

export const SurfaceCard = forwardRef<HTMLDivElement, SurfaceCardProps>(function SurfaceCard(
  { sx, children, ...rest },
  ref,
) {
  return (
    <Box ref={ref} sx={[surfaceSx, ...(Array.isArray(sx) ? sx : [sx])]} {...rest}>
      {children}
    </Box>
  );
});
